<div class="fluid-container">
  <div class="row">
    <div class="col-12 text-primary font-weight-bold mb-3 h6">
      {{'DATA_STUDIO.DATA_FILE_SUMMARY.TITLE' |translate}}
    </div>
    <div class="col-12 mb-1">
      <div class="row mb-3">
        <div class="col-12 d-flex justify-content-between mb-2">
          <span class="text-primary text-center rounded p-2 mr-2 custom-span">
            <i class="far fa-bars mr-1" [attr.aria-label]="'IMAGE_DESCRIPTION.ROWS' | translate"
              ></i>
            <small>
              {{'DATA_STUDIO.DATA_FILE_SUMMARY.ROWS' |translate}}
              {{numberOfRows}}
            </small>
          </span>
          <span class="text-primary text-center rounded p-2 custom-span">
            @if (theme$ === 'light') {
              <img [alt]="'IMAGE_DESCRIPTION.FIELDS' | translate" src="/assets/data-studio/IconFields-DarkBlue.svg" class="custom-icon mr-1">
            }
            @if (theme$ === 'dark') {
              <img [alt]="'IMAGE_DESCRIPTION.FIELDS' | translate" src="/assets/data-studio/IconFields-White.svg" class="custom-icon mr-1">
            }
            <small>
              {{'DATA_STUDIO.DATA_FILE_SUMMARY.FIELDS' |translate}}
              {{numberOfFields}}
            </small>
          </span>
        </div>
      </div>
    </div>
    @if ((dataStudioFileRquest?.signals.length <= 0 || dataStudioFileRquest?.turbines <= 0 || dataStudioFileRquest?.granularity === '' || fileName === '') && !requestedFile) {
      <div
        class="d-flex justify-content-between orange-bg p-3 mb-3">
        <i class="far fa-info-circle fa-2x color-orange pointer pt-2 mr-2" aria-hidden="true"></i>
        <div class="color-orange">
          {{'DATA_STUDIO.DATA_FILE_SUMMARY.NO_SIGNALS' |translate}}
        </div>
      </div>
    }
    @if (requestedFile) {
      <div
        class="d-flex justify-content-between green-bg p-3 mb-3">
        <i class="far fa-check fa-2x text-success pointer pt-2 mr-2" aria-hidden="true"></i>
        <div class="text-success">
          {{'DATA_STUDIO.DATA_FILE_SUMMARY.SIGNAL_SUCCESS' |translate}}
        </div>
      </div>
    }
    <div class="col-12 mb-3">
      <div class="text-grey mb-2 d-flex justify-content-between">
        <span>{{'DATA_STUDIO.DATA_FILE_SUMMARY.FILE_NAME' |translate}}</span>
      </div>
      <div class="d-flex">
        <input type="text" class="form-control w-100 file-name" [(ngModel)]="fileName" (keypress)="testNameKeyPress($event)">
      </div>
    </div>
    <div class="col-12 mb-2">
      <div class="text-grey mb-2">
        {{'DATA_STUDIO.DATA_FILE_SUMMARY.FILE_FORMAT' |translate}}
      </div>
      <div class="d-flex">
        <mat-radio-group class="text-primary" (change)="setFileType($event)">
          <mat-radio-button class="wrapping-radio-button mr-4" [value]="enumFileType.Xlsx" [checked]="true">
          MS-Excel (.xlsx)</mat-radio-button>
          @if (fileFormat !== 'onlyExcel') {
            <mat-radio-button class="wrapping-radio-button" [value]="enumFileType.Csv">
            {{'DATA_STUDIO.DATA_FILE_SUMMARY.COMMA_SEPARATED' |translate}} (.csv)</mat-radio-button>
          }
        </mat-radio-group>
      </div>
    </div>
    <div class="col-12 mb-2">
      <div class="text-grey mb-2">
        {{'DATA_STUDIO.DATA_FILE_SUMMARY.COLUMN_LAYOUT.TITLE' |translate}}
      </div>
      <div class="d-flex">
        <mat-radio-group class="text-primary" (change)="setColumnLayout($event)">
          <mat-radio-button
            class="wrapping-radio-button mr-4"
            [value]="enumColumnLayoutType.long"
            [hidden]="selectedPage === 3 && !columnLayout.oneTab && fileType === enumFileType.Xlsx"
            [checked]="false">
            {{'DATA_STUDIO.DATA_FILE_SUMMARY.COLUMN_LAYOUT.LONG' |translate}}
          </mat-radio-button>
          <mat-radio-button
            class="wrapping-radio-button mr-4"
            [value]="enumColumnLayoutType.wide"
            [hidden]="selectedPage === 3 && !columnLayout.oneTab && fileType === enumFileType.Xlsx"
            [checked]="true">
            {{'DATA_STUDIO.DATA_FILE_SUMMARY.COLUMN_LAYOUT.WIDE' |translate}}
          </mat-radio-button>

          <br [hidden]="selectedPage === 3 && !columnLayout.oneTab"/>

          <mat-checkbox [checked]="columnLayout.oneTab" (change)="setOneTab($event)" [hidden]="fileType !== enumFileType.Xlsx">
            <span class="font-size-normal-small">
              {{'DATA_STUDIO.DATA_FILE_SUMMARY.COLUMN_LAYOUT.ONE_TAB' | translate}}
            </span>
          </mat-checkbox>

        </mat-radio-group>
      </div>
    </div>
    <div class="col-12 text-center">
      @if ((dataStudioService.isRequesting$ | async) === false) {
        <lib-button
          id="data-file-summary-request-file-button"
          [size]="'custom'"
          [height]="40"
          [fontSize]="14"
          [disabled]="xlsButtonDisabled"
          [label]="'DATA_STUDIO.DATA_FILE_SUMMARY.REQUEST_FILE' |translate"
          [faIcon]="'far fa-chart-line'"
          (buttonClicked)="requestDataFile()" >
        </lib-button>
      }

      @if (numberOfFields > numberOfFieldsLimit) {
        <span class="text-red"><i class="text-red far fa-exclamation-circle"></i>&nbsp;{{'DATA_STUDIO.DATA_FILE_SUMMARY.NUMBER_OF_FIELDS_LIMIT' |translate}}</span>
      }
      @if ((dataStudioService.isRequesting$ | async)) {
        <span
          class="btn btn-light d-flex justify-content-center align-items-center w-100 spinner-button">
          {{'DATA_STUDIO.DATA_FILE_SUMMARY.REQUESTING' |translate}}
          <app-spinner class="pb-1" [floatRight]="false"></app-spinner>
        </span>
      }
    </div>
    @if (displayPreviewButton) {
      <div class="col-12 text-center mt-2">
        <lib-button
          id="data-file-summary-show-preview-button"
          [size]="'custom'"
          [height]="40"
          [fontSize]="14"
          [color]="'secondary'"
          [disabled]="previewDisabled"
                [label]="(!isPreviewSelected ? ('DATA_STUDIO.DATA_FILE_SUMMARY.SHOW_PREVIEW' |translate) : ('DATA_STUDIO.DATA_FILE_SUMMARY.CLOSE_PREVIEW' |translate)) 
                   + ((selectedPage === 1 && dateDifferenceInDays > 90) || (selectedPage === 2 && dateDifferenceInDays > 7) ? '*' : '') "
                [faIcon]="!isPreviewSelected ? 'far fa-eye' : 'far fa-eye-slash'"
          (buttonClicked)="showPreview()" >
        </lib-button>
        @if ((selectedPage === 1 && dateDifferenceInDays > 90 || selectedPage === 2 && dateDifferenceInDays > 7)) {
          <small>
            @if (selectedPage === 1 && dateDifferenceInDays > 90) {
              {{ 'DATA_STUDIO.DATA_FILE_SUMMARY.PREVIEW_DISABLED_LONGER_PERIOD_90' | translate }}
            }
            @if (selectedPage === 2 && dateDifferenceInDays > 7) {
              {{ 'DATA_STUDIO.DATA_FILE_SUMMARY.PREVIEW_DISABLED_LONGER_PERIOD' | translate }}
            }
          </small>
        }
      </div>
    }

  </div>
